/**
 * Legal Page Layout - Wrapper for Privacy, Terms, etc. with back navigation
 */
import React from 'react';
import { useNavigate, Link } from 'react-router-dom';

export default function LegalPageLayout({ children }) {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header with Back Button */}
      <header className="bg-gradient-to-r from-orange-500 to-amber-500 text-white py-4 px-6 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto flex justify-between items-center">
          <div className="flex items-center gap-4">
            <button 
              onClick={() => navigate(-1)} 
              className="flex items-center gap-2 text-white hover:text-orange-100 transition"
              data-testid="legal-back-btn"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              <span>Back</span>
            </button>
            <Link to="/" className="text-xl font-bold hover:text-orange-100">शिक्षा मित्र</Link>
          </div>
          <span className="text-sm hidden sm:block">by System Of Success</span>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto py-8 px-4">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mb-4 text-sm">
            <Link to="/privacy" className="hover:text-orange-400 transition">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-orange-400 transition">Terms & Conditions</Link>
            <Link to="/refund" className="hover:text-orange-400 transition">Refund Policy</Link>
            <Link to="/contact" className="hover:text-orange-400 transition">Contact Us</Link>
            <Link to="/about" className="hover:text-orange-400 transition">About Us</Link>
          </div>
          <Link to="/" className="text-orange-400 hover:text-orange-300 transition">← Back to Home</Link>
          <p className="text-gray-500 text-xs mt-4">© 2025 System Of Success. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
